export const EyeIcon = (
  <svg
    width="18"
    height="10"
    viewBox="0 0 21 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.291016 6.25754C3.35007 1.80075 11.5973 -4.43876 20.1137 6.25754"
      stroke="#929292"
      stroke-width="0.703704"
    />
    <path
      d="M10.2021 3.16699C12.2746 3.16711 13.9033 4.77021 13.9033 6.68555C13.9031 8.60069 12.2745 10.204 10.2021 10.2041C8.1297 10.2041 6.50122 8.60077 6.50098 6.68555C6.50098 4.77014 8.12955 3.16699 10.2021 3.16699Z"
      stroke="#929292"
      stroke-width="1.40741"
    />
    <path
      d="M0.291016 7.25418C3.35007 11.711 11.5973 17.9505 20.1137 7.25418"
      stroke="#929292"
      stroke-width="0.703704"
    />
  </svg>
);

export const BackIcon = () => {
  return (
    <svg
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6045 0H7.32698L-0.000267982 6.11813L7.32698 12.2363H10.6045L2.96906 6.11813L10.6045 0Z"
        fill="#3F3E43"
        fillOpacity="0.8"
      />
    </svg>
  );
};
